<template>
    <div class="main_container">
        <div class="layout_split">
            <RightWing :index="5" :score="score" />
            <div class="main_area">
                <div style="opacity:0; font-size:10px;">space</div>

                <div class="title_container">
                    <div class="section_title_result_view">{{sectionTitle}}</div>
                    <div class="article_title_result_view">"{{articleTitle}}"</div>
                    <img :src="committeeSaidImg" width="280">
                </div>
                <div class="article_title_mobile">
                    <div>{{articleTitle}}</div>
                </div>

                <div class="explanation_container">
                    <div v-for="(exp, idx) in explanations" :key="idx" class="explanation_item">
                        <img :src="require('../assets/img/magnify_' + (1 + idx) + '.png')" width="30" style="margin-right:10px;">
                        <span class="explanation_text">{{exp}}</span>
                    </div>
                </div>

                <div class="btn_container">
                    <div class="btn_ok" :class="buttonOkClass" @click="next">다른 주제 검토하기</div>
                </div>
                <div class="mobile_margin">space</div>
            </div>
        </div>
    </div>
</template>

<script>
import RightWing from '../components/RightWingView.vue'
export default {
    name: 'ArticleResultView',

    components: {
        'RightWing': RightWing
    },

    data() {
        return {
            sectionTitle: null,
            articleTitle: null,
            buttonOkClass: 'btn_ok_active',
            committeeSaid: null,
            committeeSaidImg: null,
            explanations: null,
            score: null,
        }
    },

    mounted() {
        const currentPlay = this.$getCurrentGame()
        const selectedArticleData = this.$gameData.sections[currentPlay.selectedSection].articles[currentPlay.selectedArticle]
        this.sectionTitle = this.$gameData.sections[currentPlay.selectedSection].title
        this.articleTitle = selectedArticleData.title
        this.score = currentPlay.score
        console.log(selectedArticleData)
        if(selectedArticleData.explanation) {
            this.explanations = selectedArticleData.explanation.split('\n')
        }

        // for(let article of currentPlay.articles) {
        //     if(article.title == this.articleTitle) {
        //         this.playerSaid = article.playerResult
        //         break;
        //     }
        // }
        this.committeeSaid = selectedArticleData.result
        if(this.committeeSaid == '사실') {
            this.committeeSaidImg = require('../assets/img/result_sign_true.png')
        }
        else if(this.committeeSaid == '판정 보류') {
            this.committeeSaidImg = require('../assets/img/result_sign_undecided.png')
        }
        else if(this.committeeSaid == '거짓') {
            this.committeeSaidImg = require('../assets/img/result_sign_false.png')
        }

    },

    methods: {
        next: function() {
            this.$router.push('/articleList')
        }
    },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.btn_ok {
    text-align: center;
    width: 280px;
    padding: 10px;
    margin: 0px 10px;
    border: 2px solid black;
    font-weight: 700;
    font-size: 26px;
    color: black;
    cursor: pointer;
}
.btn_ok_active {
    box-shadow:3px 3px 3px grey;
    background-color: white;
}
.btn_ok_inactive {
    background-color: gray;
}
.btn_container {
    margin-top: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
}



/* pc */
@media screen and (min-width: 415px) {
    .layout_split {
        display:flex;
    }
    .main_area {
        width:100%;
        background-color:#e5e5e5
    }
    .title_container {
        text-align: center;
        background: linear-gradient(#ffffff00 15%, white 15% 100%);
        padding-bottom: 20px;
        margin-top: 0px;
        margin-bottom: 30px;
        margin-right: 80px;
        margin-left: 80px;
    }
    .article_title_mobile {
        display: none;
    }
    .explanation_container {
        font-size: 20px;
        margin: 5px 80px;
    }
    .mobile_margin {
        display: none;
    }

}


/* mobile */
@media screen and (max-width: 414px) {
    .layout_split {
        display:flex;
        flex-direction:column;
    }
    .main_area {
        width:100%;
        background-color:#e5e5e5
    }
    .title_container {
        display: none;
    }
    .article_title_mobile {
        text-align: center;
        color: black;
        font-size: 22px;
        font-weight: 700;
        /* border-bottom: solid black 1px; */
        text-decoration: underline;
    }
    .explanation_container {
        font-size: 18px;
        margin: 5px 10px;
    }
    .mobile_margin {
        margin-bottom: 50px;
        opacity: 0;
    }

}

.section_title_result_view {
    padding-top: 13px;
    text-align: center;
    color: white;
    font-size: 30px;
    font-weight: 700;
    width: 200px;
    height: 70px;
    margin-left: auto;
    margin-right: auto;
    background-repeat: no-repeat;
    background-image:url("../assets/img/black_bg.png");
    background-size: 200px;
}
.article_title_result_view {
    height: 50px;
    width: 800px;
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    font-size: 26px;
    font-weight: 700;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.explanation_text {
    border-bottom: 2px solid black;
}
.explanation_item {
    background-color:white;
    margin: 10px 0px;
    padding: 15px;
}

</style>
